import {NgModule} from '@angular/core';

import {SharedModule} from '../shared/shared.module';
import {FAQRoutingModule} from './faq-routing.module';
import {FAQComponent} from './components/faq/faq.component';

const MODULES = [SharedModule, FAQRoutingModule];

const COMPONENTS = [FAQComponent];

const SERVICES = [];

@NgModule({
    imports: [...MODULES],
    providers: [...SERVICES],
    declarations: [...COMPONENTS]
})
export class FAQModule {
}
